import React, { useContext } from "react";
import { FileLocationProviderContext, SelectedItemLocation } from "./FileLocationProvider";
import { FlatPathTreeExplorer } from "../generic/FlatPathTreeExplorer";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import FooterPanel from "../layout/FooterPanel";

export interface FileLocationExplorerProps {
  onSelectItem: (itemLocation: SelectedItemLocation) => void;
  onCancelSelection: () => void;
  page?: "IMPORT" | "EXPORT" | "OPEN";
}

export const FileLocationExplorer: React.FunctionComponent<FileLocationExplorerProps> = (props) => {
  const fileLocationProvider = useContext(FileLocationProviderContext);

  function onSelectItem() {
    props.onSelectItem(fileLocationProvider?.selectedItemLocation);
  }

  function onCancelSelection() {
    props.onCancelSelection();
  }

  return (
    <div className="ms-Grid" dir="ltr">
      <FlatPathTreeExplorer
        item={fileLocationProvider.exploredLocation}
        onItemClicked={(item) => fileLocationProvider.exploreLocation(item)}
        onItemSelection={(item) => fileLocationProvider.selectItemLocation(item)}
        page={props.page}
        documentPartWithStatus={null}
        setDocumentPartWithStatus={() => {}}
      />
      <FooterPanel>
        <PrimaryButton text={formatMessage("cof.base.cancel")} style={{ float: "left" }} onClick={onCancelSelection} />
        <PrimaryButton text={formatMessage("cof.base.select")} style={{ float: "right" }} onClick={onSelectItem} />
      </FooterPanel>
    </div>
  );
};
